const passengers = {
  table: {
    headers: {
      name: 'שם',
      email: 'אימייל',
      created: 'תאריך יצירה',
      id: 'מזהה',
      profiles: 'פרופילים מצורפים',
      createdBy: 'נוצר על ידי',
      baseAddress: 'כתובת בית',
      occupationAddress: 'כתובת עבודה',
      createdAt: 'נוצר בתאריך',
      profile: 'פרופיל',
    },
  },
};

export default passengers;
